import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CloudService {

  public resourceUrl = `${environment.API_BASE_URL}`;

  constructor(
    private http: HttpClient
  ) { }

  getAllBlogs(page: number, limit: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/web/reve/section/web-blogs?PAGE=${page}&LIMIT=${limit}`)
  }

  getBlogDetails(key: any): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/web/reve/section/web-blog/details?KEY=${key}`)
  }

  getAllCaseStudies(page: number, limit: number): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/web/reve/section/case-studies?PAGE=${page}&LIMIT=${limit}`)
  }

  getCaseStudyDetails(key: any): Observable<any> {
    return this.http.get<any>(`${this.resourceUrl}/web/reve/section/case-studies/details?KEY=${key}`)
  }

}